import { translate } from "app/filters/i18nFilter";
import { formatTaxonomyPathDisplayNames } from "app/pages/sales-intelligence/utils/taxonomy-tree/path";

import type { CompetitiveLandscapeIndustryTaxonomy } from "../../types/dto";

type Props = {
    value?: CompetitiveLandscapeIndustryTaxonomy;
    /** The row is past the competitors hook limit, so its industry must not be shown. */
    isLocked?: boolean;
    onItemClick: () => void;
};

/**
 * The taxonomy counterpart of `CategoryFilterCell`: same class, same click-to-filter affordance, so
 * the two classifications are indistinguishable to the user. A native `title` carries the full path
 * instead of a tooltip component — paths run four levels deep, and this table renders every row of a
 * 100-row page, so one appended tooltip per cell would be paid on every render.
 *
 * The lock is handled here rather than upstream because the backend masks a restricted row's legacy
 * `Category` into the upgrade placeholder but leaves its taxonomy intact — so this column, unlike the
 * legacy one, would otherwise render data the account has not paid for.
 */
export const IndustryTaxonomyFilterCell = ({ value, isLocked, onItemClick }: Props) => {
    if (isLocked) {
        return <span className="category-filter-cell">{translate("grid.upgrade")}</span>;
    }

    const label = formatTaxonomyPathDisplayNames(value?.Path);

    if (!label) {
        return null;
    }

    return (
        <a
            onClick={onItemClick}
            className="category-filter-cell"
            title={label}
            data-automation="competitive-landscape-industry-taxonomy-cell"
        >
            {label}
        </a>
    );
};
IndustryTaxonomyFilterCell.displayName = "IndustryTaxonomyFilterCell";
